import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import {
  getStockonhandListByUser,
  createTransferInvoice,
  getStockAdjustReason,
} from "@/fetch/fetchStock";
import { getAllPromoter } from "@/fetch/fetchStaff";
import { transferInvoiceDialog } from "../../styles/mui/tableListTheme";
import Stack from "@mui/material/Stack";
import FormHelperText from "@mui/material/FormHelperText";
import _ from "lodash";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Collapse from "@mui/material/Collapse";
import SendIcon from "@mui/icons-material/Send";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { ThemeProvider } from "@emotion/react";
import Autocomplete from "@mui/material/Autocomplete";
export default function CreateTransferInvoiceDialog(props) {
  const {
    open,
    onClose,
    setSnackMessage,
    setSnackOpen,
    setSnackSeverity,
    fetchAll,
  } = props;

  const [allUsers, setAllUsers] = React.useState([]);
  const [reason, setReason] = React.useState([]);
  const [lists, setLists] = React.useState([]);
  const [stockValue, setStockvalue] = React.useState([]);
  const [selectedValue, setSelectedValue] = React.useState({
    fromUser: "",
    toUser: "",
    reasonIndex: "",
    remark: null,
  });
  const ERROR_TEXT = {
    fromUser: "不能為空",
    toUser: "不能為空",
    selectedGiftFrom: "請至少填1項",
    reasonIndex: "不能為空",
    remark: "不能為空",
    sameUser: "fromUser 不能與 toUser 相同",
  };
  const [formValidation, setFormValidation] = React.useState({
    fromUser: false,
    toUser: false,
    selectedGiftFrom: false,
    reasonIndex: false,
    remark: false,
    sameUser: false,
  });

  const stock = {
    stockValue: stockValue,
    handleStock: setStockvalue,
  };

  const fetchStockList = async (fromUser) => {
    const data = await getStockonhandListByUser(fromUser, "app");
    if (data && data.results) {
      const list = data.data.filter((item) => item.item?.length > 0);
      setStockvalue(new Array(list.length).fill([]));
      setLists(list);
    }
  };

  const fetchAllUsers = async () => {
    const data = await getAllPromoter();
    if (data && data.results) setAllUsers(data.data);
  };

  const fetchReason = async () => {
    const data = await getStockAdjustReason("app", undefined);
    if (data && data.results) setReason(data.data);
  };

  // const headers = [
  //   { label: "M18號碼", key: "m18_product_code" },
  //   { label: "品牌", key: "item_brand" },
  //   { label: "產品名稱", key: "item_name" },
  //   { label: "產品單價價錢", key: "item_unit_price" },
  //   { label: "is_active", key: "" },
  // ];

  const handleFromUserOnChange = (_, value) => {
    setSelectedValue((prev) => ({
      ...prev,
      fromUser: value,
    }));
  };

  const handleToUserOnChange = (_, value) => {
    setSelectedValue((prev) => ({
      ...prev,
      toUser: value,
    }));
  };

  const handleReasonOnChange = (event) => {
    setSelectedValue((prev) => ({
      ...prev,
      reasonIndex: event.target.value,
    }));
  };

  const handleRemarkOnChange = (event) => {
    setSelectedValue((prev) => ({
      ...prev,
      remark: event.target.value,
    }));
  };

  const clearFormValidation = () => {
    setFormValidation({
      fromUser: false,
      toUser: false,
      selectedGiftFrom: false,
      reasonIndex: false,
      remark: false,
    });
  };

  const onSubmit = async () => {
    const itemId = stockValue.reduce((prev, cur) => {
      cur?.length > 0 && cur?.forEach((item) => (prev = { ...prev, ...item }));
      return prev;
    }, {});
    const validation = {
      fromUser: !selectedValue.fromUser?.id,
      toUser: !selectedValue.toUser?.id,
      selectedGiftFrom: _.isEmpty(itemId),
      reasonIndex: !reason[selectedValue.reasonIndex]?.id,
      remark:
        reason[selectedValue.reasonIndex]?.key === "others" &&
        !selectedValue?.remark,
      sameUser: selectedValue.fromUser === selectedValue.toUser,
    };
    if (_.some(validation)) {
      setFormValidation(validation);
      return false;
    }
    // const checkWithRemark =
    //   !selectedValue.fromUser?.id ||
    //   !selectedValue.toUser?.id ||
    //   !reason[selectedValue.reasonIndex]?.id ||
    //   !selectedValue.remark ||
    //   _.isEmpty(itemId);

    // const checkWithoutRemark =
    //   !selectedValue.fromUser?.id ||
    //   !selectedValue.toUser?.id ||
    //   !reason[selectedValue.reasonIndex]?.id ||
    //   _.isEmpty(itemId);

    // if (
    //   reason[selectedValue.reasonIndex]?.key === "others"
    //     ? checkWithRemark
    //     : checkWithoutRemark
    // ) {
    //   setFormValidation({
    //     fromUser: !selectedValue.fromUser?.id ? "不能為空" : false,
    //     toUser: !selectedValue.toUser?.id ? "不能為空" : false,
    //     selectedGiftFrom: _.isEmpty(itemId) ? "請至少填1項" : false,
    //     reasonIndex: !reason[selectedValue.reasonIndex]?.id
    //       ? "不能為空"
    //       : false,
    //     remark:
    //       reason[selectedValue.reasonIndex]?.key === "others"
    //         ? !selectedValue?.remark
    //           ? "不能為空"
    //           : false
    //         : false,
    //   });
    //   return false;
    // } else if (selectedValue.fromUser === selectedValue.toUser) {
    //   setSnackMessage("fromUser 不能與 toUser 相同");
    //   setSnackSeverity("error");
    //   setSnackOpen(true);
    //   setTimeout(() => setSnackOpen(false), 1000);
    //   return false;
    // } else {
    const body = {
      reasonTypeId: reason[selectedValue.reasonIndex]?.id,
      selectedGiftFrom: itemId,
      selectedGiftTo: itemId,
      fromUser: selectedValue.fromUser?.id,
      toUser: selectedValue.toUser?.id,
      remark: selectedValue.remark,
    };

    await createTransferInvoice(body)
      .then((data) => {
        if (data && data.results) {
          setSnackMessage("新增成功");
          setSnackSeverity("success");
          setSnackOpen(true);
        } else {
          setSnackMessage("新增失敗");
          setSnackSeverity("error");
          setSnackOpen(true);
        }
        setTimeout(() => setSnackOpen(false), 1000);
      })
      .then(() => {
        setSelectedValue({
          fromUser: "",
          toUser: "",
          reasonTypeId: "",
          remark: "",
        });
        stock.handleStock([]);
        clearFormValidation();
        onClose();
        fetchAll();
      });
  };

  React.useEffect(() => {
    fetchAllUsers();
    fetchReason();
  }, []);

  React.useEffect(() => {
    if (open && selectedValue.fromUser) {
      fetchStockList(selectedValue.fromUser?.id);
    }
  }, [selectedValue.fromUser, open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        setSelectedValue({
          fromUser: "",
          toUser: "",
          reasonIndex: "",
          remark: "",
        });
        stock.handleStock([]);
        clearFormValidation();
        onClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <Box sx={{ mt: 2 }} />
      <DialogTitle>
        <Stack direction="row" justifyContent={"space-between"}>
          調換贈品項目
        </Stack>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <ThemeProvider theme={transferInvoiceDialog}>
          <Box
            component="form"
            noValidate
            sx={{
              display: "grid",
              gridTemplateColumns: { sm: "1fr" },
              gap: 2,
            }}
          >
            <Stack sx={{ pt: 1 }} direction={"row"} spacing={10}>
              <Autocomplete
                fullWidth
                size="small"
                disablePortal
                id="combo-box-demo"
                onChange={handleFromUserOnChange}
                getOptionLabel={(option) =>
                  option.staff_code + "\xa0".repeat(5) + option.alias
                }
                options={allUsers}
                renderInput={(params) => (
                  <TextField
                    error={
                      !!formValidation.fromUser || !!formValidation.sameUser
                    }
                    helperText={
                      formValidation.sameUser
                        ? formValidation.fromUser
                          ? ERROR_TEXT["fromUser"]
                          : ERROR_TEXT["sameUser"]
                        : ""
                    }
                    {...params}
                    label="From User"
                  />
                )}
              />
              <Autocomplete
                fullWidth
                size="small"
                disablePortal
                id="combo-box-demo"
                onChange={handleToUserOnChange}
                getOptionLabel={(option) =>
                  option.staff_code + "\xa0".repeat(5) + option.alias
                }
                options={allUsers}
                renderInput={(params) => (
                  <TextField
                    helperText={
                      formValidation.sameUser
                        ? formValidation.toUser
                          ? ERROR_TEXT["toUser"]
                          : ERROR_TEXT["sameUser"]
                        : ""
                    }
                    error={!!formValidation.toUser || !!formValidation.sameUser}
                    {...params}
                    label="To User"
                  />
                )}
              />
            </Stack>
            {selectedValue.fromUser && lists.length > 0 && (
              <FormControl>
                <Stack
                  sx={{
                    border: 1,
                    borderRadius: 2,
                    overflow: "hidden",
                    borderColor: !!formValidation.selectedGiftFrom && "red",
                  }}
                >
                  <FormHelperText
                    sx={{ textAlign: "center" }}
                    error={!!formValidation.selectedGiftFrom}
                  >
                    {formValidation.selectedGiftFrom
                      ? ERROR_TEXT["selectedGiftFrom"]
                      : ""}
                  </FormHelperText>
                  <StockList
                    {...{
                      items: lists,
                      stock,
                      setSnackMessage,
                      setSnackOpen,
                      setSnackSeverity,
                    }}
                  />
                </Stack>
              </FormControl>
            )}
            <FormControl
              sx={{ flex: 8 }}
              size="small"
              fullWidth
              error={!!formValidation.reasonIndex}
            >
              <InputLabel id="select-brands-label">原因</InputLabel>
              <Select
                required
                id="brand"
                name="brand"
                label="Brand"
                labelId="select-brands-label"
                value={selectedValue.reasonIndex}
                onChange={handleReasonOnChange}
              >
                <MenuItem disabled>請選擇</MenuItem>
                {_.map(reason, (item, key) => (
                  <MenuItem key={key} value={key}>
                    {item.reason}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText error={!!formValidation.reasonIndex}>
                {formValidation.reasonIndex ? ERROR_TEXT["reasonIndex"] : ""}
              </FormHelperText>
            </FormControl>
            <FormControl fullWidth>
              <TextField
                error={!!formValidation.remark}
                helperText={formValidation.remark ? ERROR_TEXT["remark"] : ""}
                size="small"
                id="standard-required"
                label="備註"
                onChange={handleRemarkOnChange}
                value={selectedValue.remark}
                variant="standard"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
          </Box>
        </ThemeProvider>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setSelectedValue({
              fromUser: "",
              toUser: "",
              reasonIndex: "",
              remark: "",
            });
            stock.handleStock([]);
            clearFormValidation();
            onClose();
          }}
        >
          取消
        </Button>
        <Button onClick={onSubmit} type="submit">
          新增
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function StockList({
  items,
  stock,
  setSnackMessage,
  setSnackOpen,
  setSnackSeverity,
}) {
  const [checked, setChecked] = React.useState(
    new Array(items.length).fill(false)
  );

  const handleClick = (position) => {
    const updatedCheck = checked.map((item, index) =>
      index === position ? !item : false
    );
    setChecked(updatedCheck);
  };

  const images = [
    {
      displayName: "Childlife 童年時光",
      uri: require("@/images/brand/1.png"),
    },
    {
      displayName: "Cleverin 加護靈",
      uri: require("@/images/brand/2.png"),
    },
    {
      displayName: "the GLOBALab",
      uri: require("@/images/brand/3.png"),
    },
    {
      displayName: "Holdbody",
      uri: require("@/images/brand/4.png"),
    },
    {
      displayName: "Jintan 森下仁丹",
      uri: require("@/images/brand/5.png"),
    },
    {
      displayName: "Mycosan",
      uri: require("@/images/brand/6.png"),
    },
    {
      displayName: "Proteca 保特加",
      uri: require("@/images/brand/7.png"),
    },
    {
      displayName: "Return 回本",
      uri: require("@/images/brand/8.png"),
    },
    {
      displayName: "Shaoyeh 少爺滴雞精",
      uri: require("@/images/brand/9.png"),
    },
    {
      displayName: "Proven Probiotics",
      uri: require("@/images/brand/10.png"),
    },
    {
      displayName: "Others 其他產品",
      uri: require("@/images/brand/11.png"),
    },
  ];

  React.useEffect(
    () => setChecked(new Array(items.length).fill(false)),
    [items.length]
  );
  return (
    <List
      sx={{ width: "100%", bgcolor: "background.paper" }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      {items.map((item, index) => {
        return (
          <React.Fragment key={index}>
            <ListItemButton onClick={() => handleClick(index)}>
              <ListItemAvatar>
                <Avatar
                  variant="square"
                  sx={{ width: 70, height: "auto", mr: 1 }}
                  alt=""
                  src={
                    images.filter((image) =>
                      image.displayName
                        .toUpperCase()
                        .includes(item.brand_types_name.toUpperCase())
                    )[0]?.uri
                  }
                />
              </ListItemAvatar>
              <ListItemText primary={item.brand_types_name} />
              {checked[index] ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={checked[index]} timeout="auto">
              <List component="div" disablePadding>
                {item.item.map((insideItem, insideIndex) => (
                  <ListItemButton key={insideItem.id} sx={{ pl: 4 }}>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", flex: 8, alignItems: "center" }}
                      >
                        <ListItemIcon>
                          <SendIcon />
                        </ListItemIcon>
                        <Stack>
                          <ListItemText primary={insideItem.item_name} />
                          <ListItemText
                            primary={`餘額 : ${insideItem.stockonhand_qty}`}
                          />
                        </Stack>
                      </Box>
                      <Box sx={{ flex: 2 }}>
                        <FormControl>
                          <OutlinedInput
                            value={
                              Object.values(
                                stock.stockValue[index]?.[insideIndex] ?? {}
                              )[0] || []
                            }
                            onChange={(event) => {
                              const tempValue = [...stock.stockValue];
                              const tempInsideValue = [
                                ...stock.stockValue[index],
                              ];
                              if (
                                tempInsideValue[insideIndex]?.length > 0 &&
                                event.target.value
                              ) {
                                if (
                                  parseInt(event.target.value) >
                                    insideItem.stockonhand_qty ||
                                  parseInt(event.target.value) < 0
                                ) {
                                  setSnackMessage("不能大於餘額或輸入負數");
                                  setSnackSeverity("error");
                                  setSnackOpen(true);
                                  setTimeout(() => setSnackOpen(false), 1000);
                                  return false;
                                } else {
                                  tempInsideValue[insideIndex] = {
                                    ...tempInsideValue[insideIndex],
                                    [insideItem.id]: Math.abs(
                                      parseInt(event.target.value)
                                    ),
                                  };
                                }
                              } else if (event.target.value) {
                                if (
                                  parseInt(event.target.value) >
                                    insideItem.stockonhand_qty ||
                                  parseInt(event.target.value) < 0
                                ) {
                                  setSnackMessage("不能大於餘額或輸入負數");
                                  setSnackSeverity("error");
                                  setSnackOpen(true);
                                  setTimeout(() => setSnackOpen(false), 1000);
                                  return false;
                                } else {
                                  tempInsideValue[insideIndex] = {
                                    [insideItem.id]: Math.abs(
                                      parseInt(event.target.value)
                                    ),
                                  };
                                }
                              } else {
                                delete tempInsideValue[insideIndex];
                              }
                              tempValue[index] = tempInsideValue;
                              stock.handleStock(tempValue);
                            }}
                            size="small"
                            type="number"
                            inputProps={{
                              min: 1,
                            }}
                          />
                        </FormControl>
                      </Box>
                    </Box>
                  </ListItemButton>
                ))}
              </List>
            </Collapse>
          </React.Fragment>
        );
      })}
    </List>
  );
}
